export default {
  path: "/HighlightedTopic/OccupantProtection",
  name: "Highlighted Topic - Occupant Protection",
  type: "highlightedTopic",
  htmlContent: "HT-OccupantProtection.html",
  keyPoints: [
    "Use of seat belts is defined in O.C.G.A. § 40-8-76, but the safety equipment coding on the crash report extends beyond the limits of state code and is applicable to all persons listed in the report. ",
    "Never leave this field blank. ",
    "Every effort should be made to determine the <u>Safety Equipment</u> used for every occupant involved in a KABC severity crash. Accurately reporting an occupant’s use of <u>Safety Equipment</u> will be relevant if there is a contributory negligence claim.  ",
    "Ensure that the <u>Safety Equipment</u> coded for each occupant is valid for their <u>Seating Position</u>. ",
    "More than 80% of pedestrian fatal and serious injury crashes occur in low light / dark conditions. Officers should note if reflective clothing or non-motorist lighting is applicable. ",
  ],
  keywords: [
    "seatbelt",
    "restraint",
    "safety",
    "equipment",
    "occupant",
    "protection",
    "helmet",
    "airbag",
  ],
  alert: {
    title: "This is a CRITICAL Data Item.",
    body: "This is a mandatory field on the crash report. All reports must have this field coded.  Additionally, this data item is critical to the highway safety community.  Incorrect reporting can negatively impact programming decisions and investments.",
  },
};
